import React from 'react';

/**
 * Section
 * ------------------------------------------------------------------
 * Wraps a group of related fields with a title and optional helper text.
 * Used in multi-section steps like Step 2 (Current/Past Projects) and
 * Step 4 (Review). Supports an accent color for visual distinction.
 *
 * @param {string} title - section heading
 * @param {string} helperText - small hint below the title
 * @param {'blue'|'purple'|'yellow'|'orange'|'green'} accent - color theme
 */
const CustomSection = ({ title, helperText, accent = 'blue', children, className = '' }) => {
  return (
    <div className={`amok-section amok-section--${accent} ${className}`}>
      <div className="amok-section__header">
        <h3 className="amok-section__title">{title}</h3>
        {helperText && <p className="amok-section__description">{helperText}</p>}
      </div>
      <div className="amok-section__body">
        {children}
      </div>
    </div>
  );
};

export default CustomSection;